'use client';

import { useEffect, useState } from 'react';

import { getCookie } from '@utils/cookies.util';
import { getCouponAndAffiliate } from '@utils/couponAndAffiliate.util';
import { PricingSection } from 'components/website/sections/PricingSection/PricingSection';
import { FORMULAS, PLANS } from 'consts/planIds.consts';
import { handleStripePriceFetching } from 'customization/customFunctions';
import { User } from 'firebase/auth';
import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';

export type PricingFetcherProps = {
  currency?: 'usd' | 'eur' | undefined;
  user?: User | undefined | null;
  noHeader?: boolean;
};

export const PricingFetcher = ({
  currency = undefined,
  user = undefined,
  noHeader = false,
}: PricingFetcherProps) => {
  const searchParams = useSearchParams();
  const [priceData, setPriceData] = useState<any>(undefined);
  const [currencyState, setCurrency] = useState<'usd' | 'eur'>('usd');

  const [coupon, setCoupon] = useState<string | undefined>(undefined);
  const [affiliate, setAffiliate] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchPrices = async () => {
      const { coupon, affiliate } = getCouponAndAffiliate(
        searchParams as ReadonlyURLSearchParams
      );
      const data = await handleStripePriceFetching(
        FORMULAS,
        PLANS,
        affiliate,
        coupon,
        user,
        currency
      );

      setPriceData(data);

      if (currency) setCurrency(currency);
      else setCurrency(data[Object.keys(data)[0]].currency as 'usd' | 'eur');
    };

    if (!searchParams || (!user && !currency)) return;

    setCoupon(
      (searchParams as ReadonlyURLSearchParams).get('coupon') || undefined
    );
    setAffiliate(
      (searchParams as ReadonlyURLSearchParams).get('affiliate') ||
        (searchParams as ReadonlyURLSearchParams).get('ref') ||
        getCookie('affiliate') ||
        undefined
    );

    fetchPrices();
  }, [currency, user, searchParams]);
  return (
    priceData && (
      <PricingSection
        noHeader={noHeader}
        data={priceData}
        currency={currencyState}
        coupon={coupon}
        affiliate={affiliate}
      />
    )
  );
};
